import { Button } from "@mui/material";

import styled from "styled-components";

export const StandartButton = styled(Button)`
    box-shadow: none !important;
    font-family: "Nunito", sans-serif !important;
    font-size: 15px !important;
    padding: 4px 15px !important;
    height: fit-content;
    width: fit-content;
    min-width: initial !important;
    white-space: nowrap !important;

    &.MuiButton-fullWidth {
        width: 100% !important;
    }

    &.ghost {
        color: black;
        border: 1px solid;
        border-color: #ccc;
        font-weight: 500 !important;
    }

    &.success {
        color: #2e7d32 !important;
        border-color: #2e7d32 !important;
    }

    &.black-contained {
        color: white !important;
        border-color: black !important;
        background-color: black !important;
        font-size: 14px !important;
        font-weight: 600 !important;
    }

    &.black-contained:hover {
        background-color: rgba(0, 0, 0, 0.8) !important;
    }

    &.white-shadowed {
        box-shadow: 0px 2px 4px 0px #00000040 !important;
        color: black !important;
        align-items: center !important;
        justify-content: space-between !important;
        text-transform: initial !important;
        padding: 12px 22px !important;
    }

    &.danger-outlined {
        border-width: 1px;
        border-style: solid;
        border-color: red !important;
        color: red !important;
    }
    &.danger {
        border-width: 0;
        color: red !important;
    }
    &.icon-button {
        padding: 5px !important;
        color: black !important;
        background-color: transparent !important;
        border: none;
        box-shadow: none !important;
        text-transform: none !important;
        transition:
            background-color 0.25s ease,
            color 0.25s ease;
        &:hover {
            background-color: rgba(0, 0, 0, 0.04) !important;
            color: black !important;
        }
        &:focus {
            outline: none !important;
            box-shadow: none !important;
        }
        &:active {
            outline: none !important;
            box-shadow: none !important;
        }
        &:focus-visible {
            outline: none !important;
            box-shadow: none !important;
        }
    }
    &.rounded {
        border-radius: 50% !important;
    }

    &.no-border {
        border: none;
    }
    &.warning-outlined {
        border-width: 1px;
        border-style: solid;
        border-color: #ed6c02 !important;
        color: #ed6c02 !important;
    }
    &.warning-outlined:hover {
        background-color: rgba(237, 108, 2, 0.04) !important;
    }

    &.help {
        background-color: #e6f7ec !important;
        color: #1b7a43 !important;
        font-weight: 600 !important;
        text-transform: none !important;
        padding: 8px 12px !important;
        transition:
            background-color 0.25s ease,
            color 0.25s ease;
    }
    &.help:hover {
        background-color: #14ae5c !important;
        color: #ffffff !important;
    }

    &.notification {
        background-color: #fff1e6 !important;
        color: #c2410c !important;
        font-weight: 600 !important;
        text-transform: none !important;
        padding: 8px 12px !important;
        transition:
            background-color 0.25s ease,
            color 0.25s ease;
    }
    &.notification:hover {
        background-color: #f66700 !important;
        color: #ffffff !important;
    }

    &.account {
        color: black;
        border: 1px solid;
        border-color: #ccc;
        font-weight: 500 !important;
        text-transform: none !important;
        padding: 12px 16px !important;
        transition:
            background-color 0.25s ease,
            color 0.25s ease;
    }

    &.black-outlined {
        color: black !important;
        border-width: 1px;
        border-style: solid;
        border-color: black !important;
        font-size: 14px !important;
        font-weight: 600 !important;
    }
    &.black-outlined:hover {
        background-color: rgba(0, 0, 0, 0.04) !important;
    }
`;

export default { StandartButton };
